import themeConfig from './_export.module.scss';

const {
	mobile,
	tablet,
	desktop,
	ldesktop,
	xldesktop,
	maxMobile,
	maxTablet,
	minDesktop,
	...rest
} = themeConfig;

export default {
	...rest,
	primary: themeConfig.primary,
	textExtraLight: themeConfig.textExtraLight,
	registerPrimary: themeConfig.registerPrimary,
	antdThemeConfig: {
		fontFamily: themeConfig['font-body-new'],
		colorPrimary: themeConfig.primary,
		// colorError: themeConfig.colorError, // commented as error color needs to be finalized
	},
	mobile,
	tablet,
	desktop,
	ldesktop,
	xldesktop,
	maxMobile,
	maxTablet,
	minDesktop,
};
